<template>
  <v-container ma-0 fluid grid-list-sm class="header-container">
    <v-layout row wrap>
      <v-flex
        xs12
        pa-3
        class="header-content text-xs-center white--text headline font-weight-medium"
      >Users and Managers</v-flex>
      <utility-backButton />
      <v-btn
        outline
        color="pipefishGreen"
        @click="editManager(selectedManager)"
        v-if="selectedManager.length > 0"
      >Edit Managers</v-btn>

      <v-dialog persistent v-model="dialog" max-width="800px" v-if="dialog">
        <v-card>
          <v-card-title>
            Editing {{ selectedManager.length }} {{ selectedManager.length > 1 ? 'Users' : 'User' }} Information
            <v-spacer />
            <v-icon @click="cancelEdit" color="pipefishOrange" medium>mdi-close-circle-outline</v-icon>
          </v-card-title>
          <v-card-text style="padding:2px">
            <v-container grid-list-md>
              <v-layout row wrap v-for="user in selectedManager" :key="user.ID">
                <v-flex xs3>
                  <v-text-field readonly label="Name" :value="user.FullName"></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field readonly label="Manager" :value="user.ManagerName"></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field readonly label="Active" :value="user.Active"></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field readonly label="Admin" :value="user.Admin"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-form ref="form">
              <v-container grid-list-md>
                <v-layout column >
                  <v-flex xs6>
                    <v-select
                      label="New Manager"
                      :items="displayManagers"
                      v-model="updateData.manager"
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox
                      hint="Set active status"
                      v-model="updateData.active"
                      label="Active?"
                    />
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox hint="Set Admin" v-model="updateData.admin" label="Admin?" />
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field v-if="selectedManager.length === 1" v-model="updateData.emailAddress" label="Email Address" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="pipefishOrange" @click="cancelEdit">Cancel</v-btn>
            <v-btn color="pipefishOrange" @click="removeManager" :loading="removeLoading">Remove Managers</v-btn>
            <v-btn
              :loading="showLoading"
              color="pipefishGreen"
              @click="saveEdit"
              :disabled="showLoading"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Loading icon to show that managers are being loaded -->
      <v-flex xs8 class="text-xs-center">
        <v-progress-circular color="blueBackground" indeterminate v-show="loadingManagers"></v-progress-circular>
      </v-flex>

      <!-- USER & MANAGER TABLE -->
      <v-flex xs12>
        <v-card-title>
          <span class="title font-weight-bold">Managers</span>
          <v-spacer></v-spacer>
          <div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              hide-details
              color="pipefishGreen"
            >
              <template slot="label">
                <span>Search</span>
              </template>
            </v-text-field>
          </div>
          <v-card-actions>
            <v-spacer />
            <!-- <v-btn  left color="pipefishGreen" @click="addPractice">Add</v-btn> -->
          </v-card-actions>
        </v-card-title>
        <div class="text-xs-center">
            <v-checkbox v-model="activeChecked" :label="`Filter Inactive Users`" id="active-filter" />
        </div>
        Total Shown: {{pipefishUserData.length}}
        <v-data-table
          :headers="headers"
          :items="pipefishUserData"
          :search="search"
          :sort-by="['FullName','ManagerName']"
          class="elevation-1 screenTable"
          item-key="ID"
          sort-icon="mdi-menu-down"
          hide-actions
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox v-model="selectedManager" :value="props.item"></v-checkbox>
            </td>
            <td>{{props.item.FullName}}</td>
            <td>{{ props.item.ManagerName }}</td>
            <td>{{ props.item.Active }}</td>
            <td>{{ props.item.Admin }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    activeChecked: true,
    loadingManagers: true,
    removeLoading: false,
    showLoading: false,
    search: "",
    selectedManager: [],
    dialog: false,
    managers: [],
    headers: [
      { text: "", sortable: false, value: "" },
      { text: "User", value: "FullName" },
      { text: "Manager", value: "ManagerName" },
      { text: "Active", value: "Active" },
      { text: "Admin User", value: "Admin" }
    ],
    pipefishUserData: [],
    updateData: {
      manager: {},
      active: false,
      admin: false,
      emailAddress: ''
    }
  }),
  computed: {
    ...mapState("admin", ["pipefishUsers"]),
    displayManagers: function() {
      return this.pipefishUsers.map(user => ({
        text: `${user.GivenName} ${user.Surname}`,
        value: user
      }));
    }
  },
  created() {
    var self = this;
    if (this.pipefishUsers.length == 0) {
      this.$timesheetApi.getAllUsers().then(users => {
        self.setSortedPipefishUsers(users);
      });
    }
    this.getAllManagers().then(managers => {
      self.setPipefishUserData();
    });
  },
  methods: {
    ...mapActions("admin", ["setSortedPipefishUsers"]),
    setPipefishUserData() {
      var tempPipefishUserData = [];
      for (var user in this.pipefishUsers) {
        var u = this.pipefishUsers[user];
        var temp = {};
        temp["ID"] = u.id;
        temp["FullName"] = `${u.GivenName} ${u.Surname}`;
        temp["Active"] = u.IsActive ? "Active" : "Inactive";
        temp["IsActive"] = u.IsActive;
        temp["Admin"] = u.IsAdmin ? "Admin" : "Not an Admin";
        temp["IsAdmin"] = u.IsAdmin;
        temp["EmailAddress"] = u.EmailAddress;
        temp["Manager"] = this.getManager(u);
        temp["ManagerName"] = temp["Manager"]
          ? `${temp["Manager"].managedBy.GivenName} ${temp["Manager"].managedBy.Surname}`
          : "-";
        tempPipefishUserData.push(temp);
      }
      tempPipefishUserData = tempPipefishUserData.filter(user => {
        return this.activeChecked ? user.IsActive : true; // if Active filter is checked, return on if user.IsActive is true, else return everything.
      })
      this.selectedManager = [];
      this.pipefishUserData = tempPipefishUserData;
    },
    getAllManagers() {
      var self = this;
      return this.$timesheetApi.getManagers().then(users => {
        self.managers = users;
        self.dialog = false;
        self.showLoading = false;
        self.removeLoading = false;
        self.loadingManagers = false;
      });
    },
    editManager(user) {
      if(this.selectedManager.length === 1) {
        this.updateData.active = this.selectedManager[0].IsActive
        this.updateData.admin = this.selectedManager[0].IsAdmin
        this.updateData.emailAddress = this.selectedManager[0].EmailAddress
      }
      for (var user in this.selectedManager) {
        var u = this.selectedManager[user];
        this.updateData[u.ID] = u;
      }

      this.dialog = true;
    },
    getManager(user) {
      return this.managers.find(users => users.UserAccountId == user.id);
    },
    cancelEdit() {
      this.dialog = false;
      this.showLoading = false;
      this.updateData = {
        manager: {},
        active: false,
        admin: false,
        emailAddress: ''
      };
    },
    removeManager() {
      this.removeLoading = true;
      var self = this;
      for(var user in this.selectedManager) {
        this.$timesheetApi.removeManager(this.selectedManager[user].ID)
        .then(response => {
          if(user == self.selectedManager.length - 1) {
            self.$timesheetApi.getAllUsers().then(users => {
              self.setSortedPipefishUsers(users);
              self.getAllManagers().then(() => {
                self.selectedManager = [];
                self.pipefishUserData = [];
                self.setPipefishUserData();
              });
            });
          }
        }); 
      }
    },
    saveEdit() {
      var self = this;
      this.showLoading = true;
      // console.log(this.updateData)
      for(var user in this.selectedManager) {
        if(typeof this.selectedManager[user].Manager == 'undefined') {
          if(this.updateData.manager.id) {
            // If the user doesn't current have a manager and there is no update manager, don't try set the manager.
            this.$timesheetApi.setManager( 
              this.selectedManager[user].ID,
              this.updateData.manager.id
            )
          }
        } else {
          this.$timesheetApi.updateManager(
            this.updateData[this.selectedManager[user].ID].Manager.Id, {
              UserAccountId: this.selectedManager[user].ID,
              ManagerId: this.updateData.manager.id
            }
          )
        }
        var updateUserStatusObject = {
          IsActive: this.updateData.active,
          IsAdmin: this.updateData.admin,
          EmailAddress : this.updateData.emailAddress
        }
        this.$timesheetApi.updateUserStatus(updateUserStatusObject, this.selectedManager[user].ID).then(response => {
          if(user == self.selectedManager.length - 1) {
            self.$timesheetApi.getAllUsers().then(users => {
              self.setSortedPipefishUsers(users);
              self.getAllManagers().then(() => {
                self.selectedManager = [];
                self.pipefishUserData = [];
                self.setPipefishUserData();
                self.updateData = {
                  manager: {},
                  active: false,
                  admin: false,
                  emailAddress: ''
                }
              });
            });
          }
        });
      }
    }
  },
  watch: {
    activeChecked: function(n, o) {
        console.log('CHANGED' + n + ' | ' + o);
      this.setPipefishUserData(n);
    }
  }
};
</script>

<style>
.screenTable {
  overflow: scroll;
  max-height: 70vh; 
}
</style>
